import {
  Box,
  Card,
  Container,
  Grid,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { Star } from "lucide-react";
import { useEffect, useState } from "react";
import CircleLabel from "../../components/CircleLabel";
import { useApi } from "../../contexts/ApiContext";
import { useAuth } from "../../contexts/AuthContext";
import { ResourceProvider } from "../../contexts/ResourceContext";
import withAuthentication from "../../hocs/withAuthentication";
import { navigationItems } from "../../types";
import { literalDate } from "../../utils";
import { fontSizes, colors } from "../../theme";
import { useApp } from "../../contexts/AppContext";
import { useError } from "../../contexts/ErrorContext";

const Page: React.FC = () => {
  const { user } = useAuth();
  const [userObj, setUserObj] = useState<any>(null);
  const { apiService, setLoading } = useApi();
  const { updateActions, updateBreadcrumbs } = useApp();

  const { translate } = useApp();
  const translations = translate("dashboard");

  const { showSuccess, showError } = useError();

  useEffect(() => {
    setLoading(true);
    apiService
      .get("/user")
      .then((data) => {
        console.log("user", data);
        setUserObj(data);
      })
      .finally(() => {
        setLoading(false);
      });

    updateActions([]);
    updateBreadcrumbs([{ label: "Dashboard" }]);

    return () => {
      updateBreadcrumbs([]);
    };
  }, []);

  const handleFavorite = (path: string) => {
    const favorites = userObj?.config?.favorites ?? {};
    if (favorites[path]) {
      delete favorites[path];
    } else {
      favorites[path] = 1;
    }
    const userObjCopy = { ...userObj };
    if (!userObjCopy.config) {
      userObjCopy.config = {};
    }
    userObjCopy.config.favorites = favorites;
    setUserObj(userObjCopy);
    apiService
      .post("/user", { config: JSON.stringify(userObjCopy.config) })
      .then((data) => {
        showSuccess(translations.messages.favoriteUpdated);
      })
      .catch((e) => {
        showError(translations.messages.favoriteError);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <ResourceProvider>
      <Container>
        <Stack spacing={0}>
          <Typography
            color={colors.stone[600]}
            textAlign={"left"}
            fontSize={fontSizes.sm}
            variant={"normal"}
          >
            {literalDate(new Date())}
          </Typography>
          <Typography fontSize={fontSizes["2xl"]} variant={"medium"}>
            {translations.hello}, {user.name}
          </Typography>
        </Stack>

        <Grid mt={1} container spacing={2}>
          {navigationItems
            .filter((n) => n.path !== "dashboard")
            .map((item) => (
              <Grid item xs={12} sm={6} md={4} key={item.path}>
                <Card sx={{ padding: 5, height: "100%" }}>
                  <Grid
                    container
                    justifyContent={"space-between"}
                    alignItems={"center"}
                  >
                    <Grid item>
                      <CircleLabel
                        width={40}
                        height={40}
                        color={colors.violet[50]}
                      >
                        <Box mt={1} color={colors.violet[500]}>
                          {item.icon}
                        </Box>
                      </CircleLabel>
                    </Grid>
                    <Grid item>
                      <IconButton
                        onClick={() => {
                          handleFavorite(item.path);
                        }}
                      >
                        <Star
                          color={
                            userObj?.config?.favorites?.[item.path]
                              ? colors.yellow[500]
                              : colors.stone[400]
                          }
                          fill={
                            userObj?.config?.favorites?.[item.path]
                              ? colors.yellow[500]
                              : "white"
                          }
                        />
                      </IconButton>
                    </Grid>
                  </Grid>
                  <Stack pt={2} spacing={1}>
                    <Typography fontSize={fontSizes.lg} variant="title">
                      {translations.tools[item.path].title}
                    </Typography>
                    <Typography
                      textAlign={"left"}
                      color={colors.stone[600]}
                      fontSize={fontSizes.sm}
                    >
                      {translations.tools[item.path].description}
                    </Typography>
                  </Stack>
                </Card>
              </Grid>
            ))}
        </Grid>
      </Container>
    </ResourceProvider>
  );
};

export default withAuthentication(Page);
